import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Info, Users, Globe } from 'lucide-react';
import './PrivacyPolicy.css'; // Reusing policy styling for consistency

export function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page">
      {/* Ambient backgrounds */}
      <div className="policy-bg">
        <div className="policy-bg__orb policy-bg__orb--1" />
        <div className="policy-bg__orb policy-bg__orb--2" />
        <div className="policy-bg__grid" />
      </div>

      <div className="policy-container">
        {/* Breadcrumbs */}
        <div className="policy-breadcrumbs">
          <Link to="/">Home</Link>
          <ChevronRight size={12} />
          <span>About Us</span>
        </div>

        {/* Header */}
        <header className="policy-header">
          <span className="policy-eyebrow">Discover Our Story</span>
          <h1 className="policy-title">About <span className="policy-title__accent">Us</span></h1>
          <p className="policy-subtitle">
            Luminar Entertainments is a premium event management and production company, staging spectacles with unparalleled discipline.
          </p>
        </header>

        {/* Key highlights */}
        <div className="policy-highlights">
          <div className="policy-card">
            <div className="policy-card__icon"><Info size={24} /></div>
            <h3>Our Mission</h3>
            <p>To deliver unforgettable experiences tailored to our clients' precise needs with world-class execution.</p>
          </div>
          <div className="policy-card">
            <div className="policy-card__icon"><Users size={24} /></div>
            <h3>Our Team</h3>
            <p>A passionate collective of event planners, technical experts, and creative visionaries.</p>
          </div>
          <div className="policy-card">
            <div className="policy-card__icon"><Globe size={24} /></div>
            <h3>Global Reach</h3>
            <p>Executing premium events across various cultural, corporate, and entertainment sectors.</p>
          </div>
        </div>

        {/* Main layout */}
        <div className="policy-layout">
          {/* Sidebar Index */}
          <aside className="policy-sidebar">
            <div className="policy-sidebar__sticky">
              <h3>Table of Contents</h3>
              <nav>
                <a href="#who-we-are">1. Who We Are</a>
                <a href="#what-we-do">2. What We Do</a>
                <a href="#our-values">3. Our Core Values</a>
              </nav>
            </div>
          </aside>

          {/* Content */}
          <article className="policy-content">
            <section id="who-we-are">
              <h2>1. Who We Are</h2>
              <p>
                Luminar Entertainments Private Limited is built on the belief that every event is a powerful platform for storytelling and human connection. Located in Aluva, Kerala, we orchestrate high-profile events with meticulous attention to detail and unwavering discipline. 
              </p>
            </section>

            <section id="what-we-do">
              <h2>2. What We Do</h2>
              <p>
                We cover a wide spectrum of practice areas, ensuring each occasion resonates perfectly with its intended audience:
              </p>
              <ul>
                <li><strong>Corporate Events:</strong> Conferences, product launches, and brand activations.</li>
                <li><strong>Entertainment:</strong> Large-scale music festivals, concerts, and live performances.</li>
                <li><strong>Cultural & Social:</strong> Private family events, cultural exhibitions, and religious gatherings.</li>
                <li><strong>Academic & Sporting:</strong> Marathons, college fests, and competitive tournaments.</li>
              </ul>
            </section>

            <section id="our-values">
              <h2>3. Our Core Values</h2>
              <p>
                Everything we build is rooted in our core values. We don't just plan events—we build inevitable experiences.
              </p>
              <ol>
                <li><strong>Discipline:</strong> A methodical approach to staging that leaves nothing to chance.</li>
                <li><strong>Innovation:</strong> Continuously pushing the boundaries of event technology and spatial design.</li>
                <li><strong>Integrity:</strong> Complete transparency with our partners, sponsors, and attendees.</li>
              </ol>
            </section>
          </article>
        </div>
      </div>
    </div>
  );
}
